import { BaseRuntime } from './BaseRuntime';

const READ_ONLY_2004 = {
  'cmi.completion_threshold': true,
  'cmi.credit': true,
  'cmi.entry': true,
  'cmi.launch_data': true,
  'cmi.learner_id': true,
  'cmi.learner_name': true,
  'cmi.max_time_allowed': true,
  'cmi.mode': true,
  'cmi.total_time': true,
  'cmi.time_limit_action': true,
};

export class Scorm2004Runtime extends BaseRuntime {
  constructor(opts) {
    super({ ...opts, version: '2004' });
    this.set('cmi.completion_status', 'not attempted');
    this.set('cmi.success_status', 'unknown');
    this.set('cmi.location', '');
    this.set('cmi.score.raw', '');
    this.set('cmi.score.min', '0');
    this.set('cmi.score.max', '100');
    this.set('cmi.suspend_data', '');
    this.set('cmi.exit', '');
    this.set('cmi.session_time', 'PT0S');
  }

  Initialize() {
    return this.beginCommunication();
  }

  Terminate() {
    return this.finish();
  }

  GetValue(key) {
    return this.get(key);
  }

  SetValue(key, value) {
    if (READ_ONLY_2004[key]) return 'false';
    return this.set(key, value);
  }

  Commit() {
    return this.commit();
  }

  GetLastError() {
    return this.errorCode;
  }

  GetErrorString() {
    return '';
  }

  GetDiagnostic() {
    return '';
  }
}

export function build2004Adapter(runtime) {
  return {
    Initialize: () => runtime.Initialize(),
    Terminate: () => runtime.Terminate(),
    GetValue: (k) => runtime.GetValue(k),
    SetValue: (k, v) => runtime.SetValue(k, v),
    Commit: () => runtime.Commit(),
    GetLastError: () => runtime.GetLastError(),
    GetErrorString: (c) => runtime.GetErrorString(c),
    GetDiagnostic: (c) => runtime.GetDiagnostic(c),
  };
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/runtime/Scorm2004Runtime.js